import { ApiType } from "@gymflow/common";
import { SubscriptionMembershipChangeSchedulePostDTO } from "@gymflow/types";
import { useMutation } from "@tanstack/react-query";

export const useMutationSubscriptionChangeSchedule = ({
  api,
  subscriptionId,
}: {
  api: ApiType;
  subscriptionId: number;
}) =>
  useMutation({
    mutationFn: async (params: SubscriptionMembershipChangeSchedulePostDTO) =>
      await api.profileApi.subscriptionChangeSchedule({
        subscriptionId,
        params,
      }),
  });
